import { TranslateService } from "@ngx-translate/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DialogRef, DialogService } from "@ngneat/dialog";
import { Component, inject, Input, OnChanges, SimpleChanges, TemplateRef, ViewChild } from "@angular/core";
import { slideDownUp, toggleAnimation } from "src/app/shared/animations";
import { Bill } from "src/app/shared/types/contract-types";
import { EInvoiceResponse, EInvoiceStatus } from "src/app/shared/types/e-invoice";
import { EInvoiceService } from "src/app/shared/services/e-invoice.service";
import { PrintPreviewService } from "src/app/shared/services/print-preview.service";
import { BillService } from "src/app/shared/services/bill.service";

@Component({
  selector: "app-e-invoice-actions",
  templateUrl: "./e-invoice-actions.component.html",
  animations: [toggleAnimation, slideDownUp],
  standalone: false,
})
export class EInvoiceActionsComponent implements OnChanges {
  @Input() bill!: Bill;
  @ViewChild("modalEInvoiceTemplate") modalEInvoiceTemplate!: TemplateRef<unknown>;
  @ViewChild("einvoicePdfModalTemplate") einvoicePdfModalTemplate!: TemplateRef<unknown>;
  @ViewChild("modalStornoTemplate") modalStornoTemplate!: TemplateRef<unknown>;
  public fileUrl!: string | undefined;
  isLoading = false;
  public eInvoice!: EInvoiceResponse;
  isMenuVisible = false;
  public eInvoiceStatus!: EInvoiceStatus;

  modalEInvoice!: DialogRef;
  modalPdf!: DialogRef;
  modalStorno!: DialogRef;

  private dialog = inject(DialogService);

  constructor(
    public route: ActivatedRoute,
    // public contractService: ContractService,
    public router: Router,
    public translate: TranslateService,
    private billService: BillService,
    // public invoiceService: InvoiceService,
    public printPreviewService: PrintPreviewService,
    public eInvoiceService: EInvoiceService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["bill"] && this.bill) {
      this.fetchEInvoice();
    }
  }

  sendToEInvoiceSystem(): void {
    this.modalEInvoice = this.dialog.open(this.modalEInvoiceTemplate, {
      windowClass: "modal-top",
      id: `dialog-${crypto.randomUUID()}`,
    });
  }

  closeEInvoiceModal(): void {
    this.modalEInvoice.close();
    this.fetchEInvoice();
  }

  downloadSalesInvoice(invoiceId: number): void {
    this.isLoading = true;
    const subscription = this.eInvoiceService.getSalesInvoicePdf(invoiceId).subscribe({
      next: (response) => {
        subscription.unsubscribe();
        if (!response?.pdfData) {
          this.isLoading = false;
          return;
        }
        const binaryString = atob(response?.pdfData);
        const byteArray = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          byteArray[i] = binaryString.charCodeAt(i);
        }
        const fileBlob = new Blob([byteArray], { type: "application/pdf" });
        this.fileUrl = URL.createObjectURL(fileBlob);
        this.modalPdf = this.dialog.open(this.einvoicePdfModalTemplate, {
          windowClass: "modal-top modal-xl",
          size: "lg",
          id: `dialog-${crypto.randomUUID()}`,
        });
        this.isLoading = false;
      },
      error: () => {
        subscription.unsubscribe();
        this.isLoading = false;
      },
    });
  }

  fetchEInvoice(): void {
    this.isLoading = true;
    const subscription = this.billService.getEInvoiceByBillId(this.bill.id).subscribe({
      next: (eInvoiceData) => {
        this.eInvoice = eInvoiceData;
        this.isLoading = false;
        subscription.unsubscribe();
      },
    });
  }

  toggleMenuVisibility(): void {
    this.isMenuVisible = !this.isMenuVisible;
  }

  closePdfModal(): void {
    this.modalPdf.close();
  }

  closeStornoModal(): void {
    this.modalStorno.close();
    this.fetchEInvoice();
  }

  stornoInvoice(): void {
    this.modalStorno = this.dialog.open(this.modalStornoTemplate, {
      windowClass: "modal-top",
      id: `dialog-${crypto.randomUUID()}`,
    });
  }
}
